import React from 'react';
import { Button } from './ui/button';
import { Card, CardContent } from './ui/card';
import { BarChart3, Sparkles, Scale, GraduationCap, ArrowRight, Check, Clock } from 'lucide-react';
import { mockData } from '../mock';

const iconMap = {
  BarChart3: BarChart3,
  Sparkles: Sparkles,
  Scale: Scale,
  GraduationCap: GraduationCap
};

const PlatformModules = () => {
  const { modules } = mockData;

  return (
    <section id="platform" className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="px-4 py-2 bg-blue-50 text-blue-700 rounded-full text-sm font-semibold">
            Platform Modules
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mt-6 mb-4">
            Four Strategic Platform Modules
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Phased development approach delivering systematic value at each stage
          </p>
        </div>

        {/* Modules */}
        <div className="space-y-12">
          {modules.map((module, index) => {
            const Icon = iconMap[module.icon];
            return (
              <Card
                key={module.id}
                className="overflow-hidden border-2 border-gray-100 hover:border-blue-200 transition-all duration-300 hover:shadow-xl"
              >
                <div className={`grid md:grid-cols-2 gap-0 ${index % 2 === 1 ? 'md:grid-flow-dense' : ''}`}>
                  {/* Image */}
                  <div className={`relative h-64 md:h-auto ${index % 2 === 1 ? 'md:col-start-2' : ''}`}>
                    <img
                      src={module.image}
                      alt={module.title}
                      className="w-full h-full object-cover"
                    />
                    <div className="absolute inset-0 bg-gradient-to-r from-blue-900/40 to-transparent"></div>
                    
                    {/* Development Timeline Badge */}
                    <div className="absolute bottom-4 left-4 bg-white/95 backdrop-blur-sm px-4 py-2 rounded-lg flex items-center gap-2">
                      <Clock className="w-4 h-4 text-blue-600" />
                      <span className="text-sm font-semibold text-gray-900">{module.development}</span>
                    </div>
                  </div>

                  {/* Content */}
                  <CardContent className="p-8 md:p-12 flex flex-col justify-center">
                    <div className="flex items-center gap-4 mb-6">
                      <div className="w-16 h-16 bg-blue-100 rounded-xl flex items-center justify-center">
                        <Icon className="w-8 h-8 text-blue-600" />
                      </div>
                      <div>
                        <h3 className="text-3xl font-bold text-gray-900">{module.title}</h3>
                      </div>
                    </div>
                    
                    <p className="text-gray-600 mb-6 leading-relaxed">{module.description}</p>

                    <ul className="space-y-3 mb-8">
                      {module.features.map((feature, idx) => (
                        <li key={idx} className="flex items-center text-gray-700">
                          <div className="w-6 h-6 bg-green-100 rounded-full flex items-center justify-center mr-3 flex-shrink-0">
                            <Check className="w-4 h-4 text-green-600" />
                          </div>
                          <span>{feature}</span>
                        </li>
                      ))}
                    </ul>

                    <Button className="bg-blue-600 hover:bg-blue-700 text-white w-fit group">
                      Learn More
                      <ArrowRight className="ml-2 w-4 h-4 group-hover:translate-x-1 transition-transform" />
                    </Button>
                  </CardContent>
                </div>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default PlatformModules;